import { confirmed } from 'vee-validate/dist/rules';

const handler = {
  validate: (field, options) => {
    return confirmed.validate(field, options);
  },
  params: ['target']
};

export { handler as confirmed };
